/**
 * Beast Games Cookie Banner
 * DSGVO-konform mit Kategorien
 */
class BeastCookieBanner {
  constructor() {
    this.STORAGE_KEY = 'beast-cookie-consent';
    this.VERSION = '1.0';

    this.banner = document.querySelector('[data-cookie-banner]');
    this.overlay = document.querySelector('[data-cookie-overlay]');
    this.acceptAllBtn = document.querySelector('[data-cookie-accept-all]');
    this.saveBtn = document.querySelector('[data-cookie-save]');
    this.analyticsToggle = document.querySelector('[data-cookie-analytics]');
    this.marketingToggle = document.querySelector('[data-cookie-marketing]');

    // Focus Trap für Accessibility
    this.lastFocusedElement = null;
    this.focusableElements = [];
    this.firstFocusable = null;
    this.lastFocusable = null;

    if (this.banner) {
      this.init();
    }
  }

  init() {
    // Prüfe ob Banner gezeigt werden soll
    if (this.shouldShowBanner()) {
      // Delay für bessere UX (Seite erst laden lassen)
      setTimeout(() => this.show(), 800);
    } else {
      // Consent beim Laden anwenden
      this.applyConsent();
    }

    this.bindEvents();
  }

  bindEvents() {
    // Alle akzeptieren
    this.acceptAllBtn?.addEventListener('click', () => {
      this.analyticsToggle.checked = true;
      this.marketingToggle.checked = true;
      this.saveSelection();
    });

    // Auswahl speichern
    this.saveBtn?.addEventListener('click', () => this.saveSelection());

    // Footer-Button zum erneuten Öffnen
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cookie-settings]')) {
        e.preventDefault();
        this.loadCurrentSettings();
        this.show();
      }
    });

    // Keyboard handlers (Tab Trap + Escape)
    document.addEventListener('keydown', (e) => this.handleKeydown(e));
  }

  show() {
    this.banner?.classList.add('active');
    this.overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Store last focused element
    this.lastFocusedElement = document.activeElement;

    // Get all focusable elements in banner
    if (this.banner) {
      this.focusableElements = Array.from(
        this.banner.querySelectorAll(
          'button, input, select, textarea, a, [tabindex]:not([tabindex="-1"])'
        )
      );
      this.firstFocusable = this.focusableElements[0];
      this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];

      // Focus first button after animation
      setTimeout(() => this.firstFocusable?.focus(), 100);
    }
  }

  hide() {
    this.banner?.classList.remove('active');
    this.overlay?.classList.remove('active');
    document.body.style.overflow = '';

    // Return focus to last focused element
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
      this.lastFocusedElement = null;
    }
  }

  handleKeydown(e) {
    if (!this.banner?.classList.contains('active')) return;

    // Close on Escape
    if (e.key === 'Escape') {
      this.saveSelection();
      return;
    }

    // Focus Trap on Tab
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === this.firstFocusable) {
          e.preventDefault();
          this.lastFocusable?.focus();
        }
      } else {
        // Tab
        if (document.activeElement === this.lastFocusable) {
          e.preventDefault();
          this.firstFocusable?.focus();
        }
      }
    }
  }

  shouldShowBanner() {
    const consent = this.getConsent();
    return !consent || consent.version !== this.VERSION;
  }

  getConsent() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  loadCurrentSettings() {
    const consent = this.getConsent();
    if (consent) {
      this.analyticsToggle.checked = consent.analytics || false;
      this.marketingToggle.checked = consent.marketing || false;
    }
  }

  saveSelection() {
    const preferences = {
      necessary: true,
      analytics: this.analyticsToggle?.checked || false,
      marketing: this.marketingToggle?.checked || false,
      version: this.VERSION,
      timestamp: new Date().toISOString()
    };

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(preferences));
    this.hide();
    this.applyConsent();
  }

  applyConsent() {
    const consent = this.getConsent();
    if (!consent) return;

    // Shopify Customer Privacy API
    if (window.Shopify?.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: consent.analytics,
        marketing: consent.marketing,
        preferences: true,
        sale_of_data: false
      }, () => {
        console.log('[Beast Cookies] Consent applied:', consent);
      });
    }

    // Custom Event für andere Scripts
    window.dispatchEvent(new CustomEvent('beastCookieConsent', {
      detail: consent
    }));
  }
}

// Initialisierung
document.addEventListener('DOMContentLoaded', () => {
  window.beastCookieBanner = new BeastCookieBanner();
});
